var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#ffc107",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1045 4034 c-41 -23 -77 -57 -145 -139 -225 -275 -374 -607 -447 -995 -25 -136 -25 -544 0 -680 70 -377 218 -711 430 -975 119 -148 167 -179 263 -173 116 7 197 93 197 207 0 68 -15 100 -93 192 -163 195 -282 429 -344 677 -38 152 -49 245 -49 412 0 167 11 260 49 412 62 248 181 483 342 674 80 95 95 127 95 195 0 71 -32 132 -91 173 -36 25 -54 31 -110 33 -48 2 -76 -1 -97 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3910 4039 c-81 -33 -133 -110 -133 -199 0 -67 16 -100 93 -191 175 -209 300 -466 358 -739 108 -503 -27 -1044 -359 -1439 -76 -92 -92 -124 -92 -192 0 -114 81 -200 197 -207 76 -5 121 15 182 80 201 214 373 530 458 841 60 220 71 306 71 567 0 261 -11 347 -71 567 -59 217 -143 403 -271 598 -106 162 -203 274 -265 306 -40 21 -125 25 -168 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1713 3505 c-115 -58 -296 -324 -367 -540 -107 -331 -80 -682 76 -988 79 -155 200 -310 278 -355 127 -75 292 5 315 153 13 78 -7 118 -125 259 -60 72 -109 164 -146 276 -26 79 -28 96 -28 250 0 154 2 171 28 250 47 140 95 225 189 328 85 95 108 182 68 267 -52 112 -177 155 -288 100z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3280 3520 c-102 -19 -173 -103 -173 -205 0 -68 20 -110 88 -185 104 -117 178 -270 205 -426 20 -112 9 -289 -25 -394 -44 -137 -90 -217 -186 -327 -78 -89 -98 -144 -80 -223 31 -140 190 -210 312 -138 49 29 152 145 211 238 251 394 274 880 61 1292 -49 97 -106 179 -187 271 -71 80 -146 113 -226 97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460 2864 c-142 -52 -229 -183 -218 -327 26 -318 443 -407 597 -127 33 60 36 71 36 150 0 78 -3 91 -34 148 -58 106 -144 161 -265 168 -50 3 -84 -1 -116 -12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveBold);
export default __webpack_public_path__ + "static/media/live-bold.85fa2a9c73f7aed6632042006b511b67.svg";
export { ForwardRef as ReactComponent };